<template>
  <div>
    <div
      v-if="can('acknowledgments.create')"
      class="d-flex justify-space-between align-center padding">
      <div>
        <span class="text-disabled mb-2">Користувач</span>
        <search></search>
      </div>
      <div>
        <span class="text-disabled pl-3">
          Бажаєте додати одразу декілька користувачів?
        </span>
        <Dialog></Dialog>
      </div>
    </div>

    <v-data-table
      :headers="acknowledgmentAssignmentListHeaders"
      :items="assignmentList"
      :items-per-page="-1"
      hide-default-footer
      :loading="$loading.isLoading('assignmentList')"
      density="compact">
      <template #item.fullName="{ item }">
        <div class="d-flex align-center gap-3">
          <slot :entity="item" name="item-append-icon"></slot>
          <span>
            {{
              item.assigneeTypeId === 1
                ? getPersonName(item.assignee)
                : item.assignee.name
            }}
          </span>
        </div>
      </template>
      <template #item.description="{ item }">
        {{ item?.assignee?.description || item?.assignee?.post || '---' }}
      </template>
      <template #item.actions="{ item }">
        <div
          class="d-flex justify-end"
          style="margin-right: -10px"
          @click="removeAssignment(item.id)">
          <v-btn
            :loading="$loading.isLoading('removeAssignment')"
            icon
            size="small"
            variant="text">
            <v-icon height="18px" icon="mdi-delete-forever" width="22px" />
          </v-btn>
        </div>
      </template>
    </v-data-table>
  </div>
</template>

<script lang="ts">
import { useAcknowledgment } from './index'
import { acknowledgmentAssignmentListHeaders } from '@/utils/tableHeaders'
import { getPersonName } from 'best-modules/utils'
import Search from './Search.vue'
import Dialog from './Dialog.vue'
import { useCan } from '@/composables/useCan'

export default {
  name: 'Assignment',
  components: { Search, Dialog },
  data() {
    return { acknowledgmentAssignmentListHeaders }
  },
  methods: { getPersonName },
  setup() {
    const { can } = useCan()
    const { removeAssignment, assignmentList } = useAcknowledgment()

    return {
      removeAssignment,
      assignmentList,
      can,
    }
  },
}
</script>

<style scoped lang="scss"></style>
